// 엔드포인트 URL을 생성하는 함수의 타입을 정의합니다.
export interface AdminQnaEndpointsProps {
  get_admin_question_detail: (questionId: string) => string;
  get_admin_questions_list: (
    page: number,
    size: number,
    keyword?: string,
    questionType?: string
  ) => string;
  post_admin_question_answers_add: () => string;
  put_admin_question_answers_update: (answerId: string) => string;
}

// 문의 사항 관련 엔드포인트 정의
export const AdminQnaEndpoints: AdminQnaEndpointsProps = {
  get_admin_question_detail: (questionId: string) =>
    `api/admin/qna/questions/${questionId}`, // 문의 상세 조회

  get_admin_questions_list: (page, size, keyword, questionType) => {
    let url = `api/admin/qna/questions?page=${page}&size=${size}`;
    if (keyword) {
      url += `&keyword=${encodeURIComponent(keyword)}`;
    }
    if (questionType) {
      url += `&questionType=${questionType}`;
    }
    return url;
  },

  post_admin_question_answers_add: () => `api/admin/qna/answers`, // 문의 사항 등록
  put_admin_question_answers_update: (answerId) =>
    `api/admin/qna/answers/${answerId}`, // 문의 사항 등록
};

export default AdminQnaEndpoints;
